// src/components/SalonProtectedRoute.jsx - FIXED version to prevent reload loops
import React from 'react';
import { Navigate, Outlet, useParams, useLocation } from 'react-router-dom';
import { useSalonAuth } from '../contexts/SalonAuthContext';

function SalonProtectedRoute() {
  const { currentUser, isStaff, loading } = useSalonAuth();
  const { salonId } = useParams();
  const location = useLocation();

  console.log('SalonProtectedRoute - Debug Info:', {
    currentUser: !!currentUser,
    isStaff,
    loading,
    salonId,
    pathname: location.pathname,
    userRole: currentUser?.role,
    userSalonId: currentUser?.salonId
  });

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="loading-container" style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column' 
      }}>
        <div className="loading-spinner">
          <div className="spinner" style={{
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #3498db',
            borderRadius: '50%',
            width: '50px',
            height: '50px',
            animation: 'spin 2s linear infinite'
          }}></div>
          <p style={{ marginTop: '20px' }}>Checking authentication...</p>
        </div>
      </div>
    );
  }

  // Check if user is authenticated and is salon staff
  if (!currentUser || !isStaff) {
    console.log('SalonProtectedRoute - User not authenticated or not staff, redirecting to login');
    
    // Prevent redirect loops by checking current path
    if (location.pathname.includes('/login')) {
      console.log('Already on login page, not redirecting');
      return <div>Please log in to access this page.</div>;
    }
    
    // Smart redirect logic based on URL structure
    if (location.pathname.includes('/BespokeBeauty/') && salonId) {
      const loginPath = `/BespokeBeauty/${salonId}/admin/login`;
      console.log('Redirecting to:', loginPath);
      return <Navigate to={loginPath} replace />;
    }
    
    // Fallback for legacy routes
    console.log('Redirecting to legacy login');
    return <Navigate to="/login" replace />;
  }

  // User is authenticated and is salon staff
  console.log('SalonProtectedRoute - User authenticated, allowing access');
  return <Outlet />;
}

export default SalonProtectedRoute;